module.exports = __webpack_public_path__ + "static/media/bgbox1.095f402f.jpg";